import React from 'react';
import { styled } from 'dripsy';
import { View } from 'react-native';

import { ILoaderProps, Loader } from './Loader';

const Container = styled(View)({
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  bg: '$background0',
});

export interface IScreenLoaderProps extends ILoaderProps {}

export function ScreenLoader(props: IScreenLoaderProps) {
  return (
    <Container>
      <Loader size="large" {...props} />
    </Container>
  );
}
